<template>
    <div>
        <div class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="card card-primary card-outline">
                <div class="form-group card-header bg-white pt-2 pb-1 text-right">
                    <label class="fa-pull-left">Announcement Details</label>
                    <button type="button" class="btn btn-flat bg-secondary btn-sm"  @click="loadpage('list_annocement')"><i class="fa fa-list"></i> List</button>
                    <button type="button" class="btn btn-flat bg-blue btn-sm" @click="loadpage('create_annocement')"><i class="fa fa-plus"></i>Create Announcement</button>
                </div>
                <div class="form-group">
                    <div class="col-12">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods:{
         loadpage:function(type){
            this.$router.push({name:type});
        },
    },
    mounted() {
        let routeparam=this.$route.query.data;
        this.sub_mod_id=routeparam;
    },

}
</script>

